
define('text!templates/components/customer_note/customer_note.html',[],function () { return '<td data-cell="created">\n    <%= user.first_name %> <%= user.last_name %>\n</td>\n\n<td data-cell="created">\n    <%= App.utils.convertToTimezone(created) %>\n</td>\n\n<td data-cell="note">\n    <%= _.escape(note) %>\n</td>\n';});

